import { connect } from "react-redux";
import {
  editAppointmentModalUpdate,
  editAppointmentModalConfirm,
  toggleApptEditCrew,
  editAppointmentModalUpdateConfirm,
  editAppointmentModalIndividualConfirm,
  editAppointmentModalSplitConfirm,
  toggleAppointmentModal,
} from "../../../redux/modals";
import AppointmentCalendarModal from "./AppointmentCalendarModal";
import {
  searchCustomers,
  searchDatasheets,
} from "../../../redux/searchAppointments";
import { toggleAppointmentCrew } from "../../../redux/modals/appintmentCalendarModal";

const mapStateToProps = (state) => ({
  ...state,
  show: state.modals.appintmentCalendarModal.show,
  loading: state.modals.appintmentCalendarModal.loading,
  appointmentTypes: state.dropdowns.appointmentTypes,
  customers: state.searchAppointments.customers,
  equipment: state.modals.appintmentCalendarModal.equipment,
  resources: state.modals.appintmentCalendarModal.resources,
  datasheets: state.searchAppointments.datasheets,
  employees: state.searchEmployees.employees,
  isApptEditCrewEnabled:
    state.modals.appintmentCalendarModal.isApptEditCrewEnabled,
  form: state.modals.appintmentCalendarModal.form,
});

const mapDispatchToProps = {
  onChange: editAppointmentModalUpdate,
  //onConfirm: (evt)=> Object.keys(evt).length===0? editAppointmentModalConfirm:editAppointmentModalUpdateConfirm,
  onConfirm: editAppointmentModalConfirm,
  onIndividualConfirm: editAppointmentModalIndividualConfirm,
  onSplitConfirm: editAppointmentModalSplitConfirm,
  onEditConfirm: editAppointmentModalUpdateConfirm,
  onHide: () => toggleAppointmentModal({ show: false }),
  onToggleEditCrew: toggleAppointmentCrew,
  onSearchCustomers: searchCustomers,
  onSearchDatasheets: searchDatasheets,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AppointmentCalendarModal);
